import api from '@/services/api'
import type { Brand, ChangePasswordPayload, UpdateBrandPayload } from './types'

export const getBrand = async (): Promise<Brand> => {
  const response = await api.get('/brands')
  return response.data
}

export const changePassword = async (data: ChangePasswordPayload): Promise<Brand> => {
  const response = await api.put('/brands/password', data)
  return response.data
}

export const updateBrand = async (data: UpdateBrandPayload): Promise<Brand> => {
  const response = await api.put('/brands', data)
  return response.data
}
